import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=2e6ba359"
import script from "./minimal.vue?vue&type=script&lang=js"
export * from "./minimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GlobalsLayoutLoader: require('/opt/build/repo/node_modules/@pleinair/bigcolony-vue/components/_globals/layout/Loader.vue').default})
